import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from '../public/locales/en/translation.json';
import jaTranslation from '../public/locales/ja/translation.json';

// Get stored language preference, default to Japanese if none
const getStoredLanguage = () => {
  const storedLanguage = localStorage.getItem('preferredLanguage');
  return storedLanguage || 'ja';
};

// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ja: { translation: jaTranslation },
    },
    fallbackLng: 'ja',
    lng: getStoredLanguage(),
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
    
    ns: ['translation'],
    defaultNS: 'translation',
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'preferredLanguage',
      // Force Japanese if no language is detected
      checkWhitelist: true,
      whitelist: ['ja', 'en']
    }
  });

// Set default language to Japanese if not already set
if (!localStorage.getItem('preferredLanguage')) {
  localStorage.setItem('preferredLanguage', 'ja');
  i18n.changeLanguage('ja');
}

export default i18n; 